var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import moment from "moment";
import React, { useCallback, useEffect, useReducer, useRef, useState, } from "react";
import FIIChart from "./chart";
import styles from "./fii.module.scss";
import { intComma } from "src/utils/methods";
import Loader from "src/components/loader/loader";
import { captureCleverTabAnalytics } from "src/utils/analytics";
import { dashboardWorkerRef } from "src/apis/dashboard.controller";
import { v4 as uuid } from "uuid";
const FII = React.forwardRef((_a, ref) => {
    var { children } = _a, others = __rest(_a, ["children"]);
    const reducer = (state, action) => {
        switch (action.type) {
            case "diiCashBuy":
                return Object.assign(Object.assign({}, state), { diiCashBuy: action.payload });
            case "fiiCashBuy":
                return Object.assign(Object.assign({}, state), { fiiCashBuy: action.payload });
            case "fiiIdxFutBuy":
                return Object.assign(Object.assign({}, state), { fiiIdxFutBuy: action.payload });
            case "fiiStkFutBuy":
                return Object.assign(Object.assign({}, state), { fiiStkFutBuy: action.payload });
            case "fiiIdxOptBuy":
                return Object.assign(Object.assign({}, state), { fiiIdxOptBuy: action.payload });
            case "fiiStkOptBuy":
                return Object.assign(Object.assign({}, state), { fiiStkOptBuy: action.payload });
            case "diiCashSell":
                return Object.assign(Object.assign({}, state), { diiCashSell: action.payload });
            case "fiiCashSell":
                return Object.assign(Object.assign({}, state), { fiiCashSell: action.payload });
            case "fiiIdxFutSell":
                return Object.assign(Object.assign({}, state), { fiiIdxFutSell: action.payload });
            case "fiiStkFutSell":
                return Object.assign(Object.assign({}, state), { fiiStkFutSell: action.payload });
            case "fiiIdxOptSell":
                return Object.assign(Object.assign({}, state), { fiiIdxOptSell: action.payload });
            case "fiiStkOptSell":
                return Object.assign(Object.assign({}, state), { fiiStkOptSell: action.payload });
            default:
                throw new Error();
        }
    };
    const [loading, setLoading] = useState(true);
    const [state, dispatch] = useReducer(reducer, {
        diiCashBuy: 0,
        fiiCashBuy: 0,
        fiiIdxFutBuy: 0,
        fiiStkFutBuy: 0,
        fiiIdxOptBuy: 0,
        fiiStkOptBuy: 0,
        diiCashSell: 0,
        fiiCashSell: 0,
        fiiIdxFutSell: 0,
        fiiStkFutSell: 0,
        fiiIdxOptSell: 0,
        fiiStkOptSell: 0,
    });
    //-------------------------DO NOT DELETE ANY COMMENTED CODE---------------------------------------------------------------
    // const [oneWeekSumInfo, setOneWeekSumInfo] = useState({
    //   diiCashBuy: 0,
    //   fiiCashBuy: 0,
    //   fiiIdxFutBuy: 0,
    //   fiiStkFutBuy: 0,
    //   fiiIdxOptBuy: 0,
    //   fiiStkOptBuy: 0,
    //   diiCashSell: 0,
    //   fiiCashSell: 0,
    //   fiiIdxFutSell: 0,
    //   fiiStkFutSell: 0,
    //   fiiIdxOptSell: 0,
    //   fiiStkOptSell: 0,
    // });
    const [oneWeekObj, setOneWeekObj] = useState({});
    const [fiiRange, setFiiRange] = useState("1D");
    const [oneDay, setOneDay] = useState("");
    // const [data, setData] = useState<fiidiiType>();
    const searchUIDRef = useRef(uuid());
    const fetchFiidii = useCallback((value) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const fiiResp = yield dashboardWorkerRef.getFiidiiImpl(searchUIDRef.current);
            if (value == "1D") {
                const allAvailableData = fiiResp.data.body.day;
                const dates = Object.keys(allAvailableData);
                const oneWeekInfo = {};
                //const sum = { ...oneWeekSumInfo };
                const sum = Object.assign({}, state);
                const dateValue = new Date(dates[0]);
                const splittedValues = dateValue.toString().split(" ");
                const finalDateValue = splittedValues[2] +
                    " " +
                    splittedValues[1] +
                    ", " +
                    splittedValues[3];
                setOneDay(finalDateValue);
                setLoading(false);
                getRelevantData(allAvailableData, dates, oneWeekInfo, sum);
            }
            else if (value == "1M") {
                const allAvailableData = fiiResp.data.body.month;
                const dates = Object.keys(allAvailableData);
                const oneWeekInfo = {};
                //const sum = { ...oneWeekSumInfo };
                const sum = Object.assign({}, state);
                getRelevantData(allAvailableData, dates, oneWeekInfo, sum);
                setLoading(false);
            }
            else if (value == "1Y") {
                const allAvailableData = fiiResp.data.body.year;
                const dates = Object.keys(allAvailableData);
                const passedDateArray = dates.reverse();
                const oneWeekInfo = {};
                // const sum = { ...oneWeekSumInfo };
                const sum = Object.assign({}, state);
                setLoading(false);
                getRelevantData(allAvailableData, passedDateArray, oneWeekInfo, sum);
            }
        }
        catch (err) {
            console.error(err);
        }
    }), []);
    function getRelevantData(allAvailableData, dates, oneWeekInfo, sum) {
        dates
            .slice(0, 1)
            .reverse()
            .forEach((date) => {
            dispatch({
                type: "diiCashBuy",
                payload: Number(allAvailableData[date].DII_PROV_EQTY_BUY),
            });
            dispatch({
                type: "fiiCashBuy",
                payload: Number(allAvailableData[date].FII_PROV_EQTY_BUY),
            });
            dispatch({
                type: "fiiIdxFutBuy",
                payload: Number(allAvailableData[date].FII_FNO_INDEX_FUT_BUY),
            });
            dispatch({
                type: "fiiStkFutBuy",
                payload: Number(allAvailableData[date].FII_FNO_STOCK_FUT_BUY),
            });
            dispatch({
                type: "fiiIdxOptBuy",
                payload: Number(allAvailableData[date].FII_FNO_INDEX_OPT_BUY),
            });
            dispatch({
                type: "fiiStkOptBuy",
                payload: Number(allAvailableData[date].FII_FNO_STOCK_OPT_BUY),
            });
            dispatch({
                type: "diiCashSell",
                payload: Number(allAvailableData[date].DII_PROV_EQTY_SELL),
            });
            dispatch({
                type: "fiiCashSell",
                payload: Number(allAvailableData[date].FII_PROV_EQTY_SELL),
            });
            dispatch({
                type: "fiiIdxFutSell",
                payload: Number(allAvailableData[date].FII_FNO_INDEX_FUT_SELL),
            });
            dispatch({
                type: "fiiStkFutSell",
                payload: Number(allAvailableData[date].FII_FNO_STOCK_FUT_SELL),
            });
            dispatch({
                type: "fiiIdxOptSell",
                payload: Number(allAvailableData[date].FII_FNO_INDEX_OPT_SELL),
            });
            dispatch({
                type: "fiiStkOptSell",
                payload: Number(allAvailableData[date].FII_FNO_STOCK_OPT_SELL),
            });
            // sum.fiiIdxFutBuy = Number(
            //   allAvailableData[date].FII_FNO_INDEX_FUT_BUY
            // );
            // sum.fiiIdxFutSell = Number(
            //   allAvailableData[date].FII_FNO_INDEX_FUT_SELL
            // );
            // sum.fiiStkFutBuy = Number(
            //   allAvailableData[date].FII_FNO_STOCK_FUT_BUY
            // );
            // sum.fiiStkFutSell = Number(
            //   allAvailableData[date].FII_FNO_STOCK_FUT_SELL
            // );
            // sum.fiiIdxOptBuy = Number(
            //   allAvailableData[date].FII_FNO_INDEX_OPT_BUY
            // );
            // sum.fiiIdxOptSell = Number(
            //   allAvailableData[date].FII_FNO_INDEX_OPT_SELL
            // );
            // sum.fiiStkOptBuy = Number(
            //   allAvailableData[date].FII_FNO_STOCK_OPT_BUY
            // );
            // sum.fiiStkOptSell = Number(
            //   allAvailableData[date].FII_FNO_STOCK_OPT_SELL
            // );
            // sum.fiiCashBuy = Number(allAvailableData[date].FII_PROV_EQTY_BUY);
            // sum.fiiCashSell = Number(allAvailableData[date].FII_PROV_EQTY_SELL);
            // sum.diiCashBuy = Number(allAvailableData[date].DII_PROV_EQTY_BUY);
            // sum.diiCashSell = Number(allAvailableData[date].DII_PROV_EQTY_SELL);
            oneWeekInfo[date] = allAvailableData[date];
            if (sum.fiiCashBuy == 0 || sum.fiiCashSell == 0) {
                dates
                    .slice(1, 2)
                    .reverse()
                    .forEach((data) => {
                    sum.fiiCashBuy = Number(allAvailableData[data].FII_EQTY_BUY);
                    sum.fiiCashSell = Number(allAvailableData[data].FII_EQTY_SELL);
                });
            }
        });
        setOneWeekObj(oneWeekInfo);
        // setOneWeekSumInfo(sum);
    }
    useEffect(() => {
        fetchFiidii(fiiRange);
    }, []);
    const onFiiRangeChange = useCallback((value) => {
        setFiiRange(value);
        fetchFiidii(value);
    }, [fiiRange]);
    const captureExpandClick = () => {
        captureCleverTabAnalytics("Expand_Click", {
            Initiation_Screen: "FII_DII",
        });
    };
    // const fetchData = useCallback(() => {
    //   Object.keys(oneWeekObj).forEach((key) => {
    //     const currentItem = oneWeekObj[key];
    //     setData(currentItem);
    //   });
    // }, [oneWeekObj]);
    // useEffect(() => {
    //   fetchData();
    // }, [oneWeekObj]);
    return (
    // <Profiler id={"FII"} onRender={onRenderCallback}>
    _jsx("div", Object.assign({ ref: ref }, others, { children: _jsxs("div", Object.assign({ className: `${styles.fiiContainer}` }, { children: [_jsxs("div", Object.assign({ className: styles.sectionHeader }, { children: [_jsx("span", Object.assign({ className: `${styles.sectionTitle} mediumWeight` }, { children: "FII/DII" })), _jsxs("ul", Object.assign({ className: styles.dateTabList }, { children: [_jsx("li", Object.assign({ className: fiiRange == "1D" ? styles.active : "", onClick: () => {
                                        onFiiRangeChange("1D");
                                    } }, { children: oneDay && moment(oneDay).format("DD MMM") })), _jsx("li", Object.assign({ className: fiiRange == "1M" ? styles.active : "", onClick: () => {
                                        onFiiRangeChange("1M");
                                    } }, { children: "1M" })), _jsx("li", Object.assign({ className: fiiRange == "1Y" ? styles.active : "", onClick: () => {
                                        onFiiRangeChange("1Y");
                                    } }, { children: "1Y" })), _jsx("li", Object.assign({ onClick: captureExpandClick }, { children: _jsx("a", { href: "/fii-dii", className: "maximizeIcon" }) }))] }))] })), _jsx("div", Object.assign({ className: styles.chartWrapper }, { children: loading ? (_jsx(Loader, {})) : (_jsx(FIIChart, { data: oneWeekObj, range: fiiRange })) })), _jsxs("div", Object.assign({ className: `${styles.sectionContent}` }, { children: [_jsxs("div", Object.assign({ className: `${styles.tableHeader} mt-2` }, { children: [_jsx("div", { className: styles.tableColFirst }), _jsx("div", Object.assign({ className: `${styles.tableCol}` }, { children: _jsx("span", Object.assign({ className: "small" }, { children: "DII CASH*" })) })), _jsx("div", Object.assign({ className: `${styles.tableCol}` }, { children: _jsx("span", Object.assign({ className: "small" }, { children: "FII CASH*" })) })), _jsx("div", Object.assign({ className: `${styles.tableCol}` }, { children: _jsx("span", Object.assign({ className: "small" }, { children: " FII IDX FUT " })) })), _jsx("div", Object.assign({ className: `${styles.tableCol}` }, { children: _jsx("span", Object.assign({ className: "small" }, { children: " FII STK FUT " })) })), _jsx("div", Object.assign({ className: `${styles.tableCol}` }, { children: _jsx("span", Object.assign({ className: "small" }, { children: " FII IDX OPT " })) })), _jsx("div", Object.assign({ className: `${styles.tableCol}`, style: { border: "none" } }, { children: _jsx("span", Object.assign({ className: "small" }, { children: " FII STK OPT " })) }))] })), _jsxs("div", Object.assign({ className: `${styles.tableData} ` }, { children: [_jsx("div", Object.assign({ className: styles.tableColFirst }, { children: _jsx("span", { className: "net-buy text-uppercase" }) })), _jsx("div", Object.assign({ className: styles.tableCol }, { children: _jsxs("span", Object.assign({ className: `small ${state.diiCashBuy - state.diiCashSell > 0
                                            ? "net-buy"
                                            : "net-sell"}` }, { children: [intComma(Math.floor(Math.abs(state.diiCashBuy - state.diiCashSell))), " ", "Cr"] })) })), _jsx("div", Object.assign({ className: styles.tableCol }, { children: _jsxs("span", Object.assign({ className: `small ${state.fiiCashBuy - state.fiiCashSell > 0
                                            ? "net-buy"
                                            : "net-sell"}` }, { children: [intComma(Math.floor(Math.abs(state.fiiCashBuy - state.fiiCashSell))), " ", "Cr"] })) })), _jsx("div", Object.assign({ className: styles.tableCol }, { children: _jsxs("span", Object.assign({ className: `small ${state.fiiIdxFutBuy - state.fiiIdxFutSell > 0
                                            ? "net-buy"
                                            : "net-sell"}` }, { children: [intComma(Math.floor(Math.abs(state.fiiIdxFutBuy - state.fiiIdxFutSell))), " ", "Cr"] })) })), _jsx("div", Object.assign({ className: styles.tableCol }, { children: _jsxs("span", Object.assign({ className: `small ${state.fiiStkFutBuy - state.fiiStkFutSell > 0
                                            ? "net-buy"
                                            : "net-sell"}` }, { children: [intComma(Math.floor(Math.abs(state.fiiStkFutBuy - state.fiiStkFutSell))), " ", "Cr"] })) })), _jsx("div", Object.assign({ className: styles.tableCol }, { children: _jsxs("span", Object.assign({ className: `small ${state.fiiIdxOptBuy - state.fiiIdxOptSell > 0
                                            ? "net-buy"
                                            : "net-sell"}` }, { children: [intComma(Math.floor(Math.abs(state.fiiIdxOptBuy - state.fiiIdxOptSell))), " ", "Cr"] })) })), _jsx("div", Object.assign({ className: styles.tableCol, style: { border: "none" } }, { children: _jsxs("span", Object.assign({ className: `small ${state.fiiStkOptBuy - state.fiiStkOptSell > 0
                                            ? "net-buy"
                                            : "net-sell"}` }, { children: [intComma(Math.floor(Math.abs(state.fiiStkOptBuy - state.fiiStkOptSell))), " ", "Cr"] })) }))] }))] })), _jsx("div", Object.assign({ className: `${styles.provisionalText} medium` }, { children: _jsx("span", { children: "*Provisional Data" }) }))] })) }))
    // </Profiler>
    );
});
FII.displayName = "FII";
export default FII;
